<template>
  <div style="height: 100%">
    <div class="row response_table">
      <div class="header_devices">
        <h4 v-if="devices.length > 0" class="title">{{ translate('simcard_devices.device_history') }}</h4>
        <h4 v-else class="title">{{ translate('simcard_devices.device_history_empty') }}</h4>
      </div>
      <table v-if="devices.length > 0">
        <thead style="flex: 0">
          <tr>
            <th scope="col">
              {{ translate('device.history.slot') }}
            </th>
            <th scope="col">
              {{ translate('device.history.fid') }}
            </th>
            <th scope="col">
              {{ translate('device.history.name') }}
            </th>
            <th scope="col">
              {{ translate('device.history.time') }}
            </th>
          </tr>
        </thead>
        <tbody>
          <router-link
            v-for="(dev, key) in devices"
            :key="key"
            :to="get_name_link(dev.device_fid)"
            class="link"
          >
            <tr class="device">
              <td>
                {{ dev.slot }}
              </td>
              <td data-label="fid">
                {{ dev.device_fid }}
              </td>
              <td data-label="name">
                {{ dev.device_name }}
              </td>
              <td data-label="ts">
                {{ get_date(dev.timestamp) }}
              </td>
            </tr>
          </router-link>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SimcardDeviceHistory',
  props: {
    profile: {
      type: Object,
      default: null
    }
  },
  data () {
    return {
      devices: {},
      error: false
    }
  },
  computed:{
    sim_id () { return this.$route.params.simcard_devices_id },
  },

  methods: {
    get_name_link (fid) {
      if (this.$store.getters.getPermissions.permissionGod) {
        return {path: '/device/' + fid}
      }
    },
    get_device_history(){
      if (this.$route.name === 'simcard_devices_section') {
        this.$http.v1.getSimcardDeviceHistory(this.profile.imsi, (response) => {
          if(typeof(response.data.status) != "undefined" && response.data.status !== null) {
            this.error = true
          }else{
            this.devices = response.data
          }
        })
      }
    }
  },
  watch: {
    sim_id () {
      this.get_device_history()
    }
  },
  mounted () {
    this.get_device_history()
  }
}
</script>
<style lang="scss">
  .header_devices{
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 10px;
    h4.title{
      font-size: 12px;
      line-height: 120%;
      font-weight: bold;
    }
    .switch{
      font-size: 12px;
      line-height: 120%;
    }
  }
  .link {
    cursor: pointer;
    color: #252422;
    .device{
      transition: 0.2s;
      &:hover{
        color: black;
        background-color: #eee;
      }
    }

  }
 </style>
